import http from '@/services/rest/rest.service';
import {IOptionsModel, IOptionsUpdateModel} from '@/entities/options';

export default {
    get(): Promise<IOptionsModel[]> {
        return http.get('options');
    },
    update(models: IOptionsUpdateModel[]): Promise<void> {
        return http.post('options', models);
    },
};
